import { useEffect } from 'react';
import i18n from 'helpers/i18n';
import messages from './messages';
import { Icon } from 'semantic-ui-react';
import useAsync from 'hooks/useAsync';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AccountManager from 'components/Organization/AccountManager';
import { getCurrentAccount } from 'components/Organization/AccountManager/utils';
import { getAccountsByArea } from 'actions/accountManager/accounts';
import { useGetSettings } from 'actions/envScales/settings';
import { SelectedAccount } from 'types/api/Account';
import useCurrentUser from 'hooks/useCurrentUser';
import VideosHome from 'components/Measure/Home/VideosHome';
import videosHomeMessages from 'components/Measure/Home/VideosHome/messages';
import DefaultHome from 'components/Measure/Home/DefaultHome';
import defaultHomeMessages from 'components/Measure/Home/DefaultHome/messages';
import PageLoader from 'components/PageLoader';

import {
  EmptyObservations,
  NoObservationsMessage,
  EmptyMessageContainer
} from './Styled';

const AREA = 'DataCollection';

function Home() {
  const currentUser = useCurrentUser();

  const {
    data: accounts,
    run: runAccounts,
    isPending: isLoadingAccounts
  } = useAsync<SelectedAccount[]>({ data: [] });

  const currentAccountId = getCurrentAccount(
    currentUser.current_account_id,
    accounts
  );

  const preSelectedAccount: SelectedAccount = {
    id: currentAccountId,
    guid: '',
    name: ''
  };

  const currentAccount = isLoadingAccounts
    ? preSelectedAccount
    : accounts.find(a => a.id === currentAccountId);

  const currentAccountGuid = currentAccount?.guid;
  const { data: settings, isPending: isLoadingSettings } =
    useGetSettings(currentAccountGuid);

  useEffect(() => {
    runAccounts(getAccountsByArea(AREA));
  }, [runAccounts]);

  const isAccountSelected = currentAccountId > 0;
  const isVideoAccount = settings?.video_enabled;

  useDocumentTitle(
    i18n.ft(
      isVideoAccount
        ? videosHomeMessages.header
        : defaultHomeMessages.measurement
    )
  );

  return (
    <div>
      <AccountManager
        area={AREA}
        accounts={accounts}
        currentAccountId={currentAccountId}
        isLoadingAccounts={isLoadingAccounts}
      />

      {isLoadingAccounts ? (
        <PageLoader />
      ) : isAccountSelected ? (
        isLoadingSettings ? (
          <PageLoader />
        ) : isVideoAccount ? (
          <VideosHome account={currentAccount!} accountSettings={settings!} />
        ) : (
          <DefaultHome
            key={currentAccount!.id}
            account={currentAccount!}
            accountSettings={settings!}
          />
        )
      ) : (
        <EmptyObservations>
          <Icon size="big" color="red" name="attention" />
          <EmptyMessageContainer>
            <NoObservationsMessage>
              {i18n.ft(messages.selectAccount)}
            </NoObservationsMessage>
          </EmptyMessageContainer>
        </EmptyObservations>
      )}
    </div>
  );
}

export default Home;
